import { Component, OnInit,ViewEncapsulation,ChangeDetectorRef, ViewChild, TemplateRef } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { ServicesService } from './service.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TableKeyEnum } from '../../../core/enum/table-key.enum';
import { MatTableDataSource } from '@angular/material';
import { Subscription } from 'rxjs';
import { SearchControlTypeEnum, SearchDataTypeEnum } from '../../../core/enum/searchType.enum';
import { SearchService } from '../../../services/search.service';
import { OldAbstractBaseListComponent } from '../../../components/base/old-abstract-base-list-component';
import { AclConstants } from '../../aclOperationConstants';
import { AclClassConstants } from '../../aclClassConstants';
import { LoginService } from '../../login/login.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})
export class ServiceComponent extends OldAbstractBaseListComponent implements OnInit {
  @ViewChild('actionBtn', { static: false }) actionBtnRef: TemplateRef<any>;
  @ViewChild('serviceName', { static: false }) serviceNameReff: TemplateRef<any>;
  AclClassConstants = AclClassConstants;
  AclConstants = AclConstants;
  public loginService: LoginService;
  serviceDataForGrid: any = { content: [] };
  serviceGridSettings: any = {};
  selectForUpdate: any;
  show_update: any = false;
  parentServiceList: any = false;
  filteredServiceDataForGrid: any = [];
  insertServiceForm = new FormGroup({
    service_name: new FormControl('', [Validators.required])
  });
  // config for n-table
  tableKeyEnum = TableKeyEnum;
  allColumns: any[] = [];
  dataSource = new MatTableDataSource([]);
  serviceNeoGridSettings : any = {};
  // For advance search
  searchSettings = [];
  subscriptions: Subscription[] = [];

  constructor(
    private serviceService: ServicesService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private searchService: SearchService,
    private tosterservice : ToastrService,
    loginService: LoginService
    ) {
      super(searchService);
      this.loginService = loginService;
    }

  ngAfterViewInit() {
    this.allColumns.forEach((col) => {
      if (col.colKey == 'actionCol') {
        col.customControls = [this.actionBtnRef];
      }
      if (col.colKey == 'service_name') {
        col.customControls = [this.serviceNameReff];
      }
    });
  }

  setGridSetting() {
    let self = this;
    this.allColumns = [
      {
        colKey: 'index',
        default: 'ID',
        rowKey: 'id',
        width: '3%',
        isFilterAllow: false,
        isNumber: true,
      },
      {
        colKey: 'service_name',
        default: 'Service Name',
        rowKey: 'service_name',
        width: '40%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'updatedate',
        default: 'Last Modified',
        rowKey: 'updatedate',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'actionCol',
        default: 'Action',
        rowKey: 'id',
        //enableEdit: true,
        // enableDelete: true,
        enableEdit: false,
        enableDelete: false,
        isFilterAllow: false,
        enableSort: false,
        isExpandable: false,
        isNumber: false,
        width: '1%',
        isStickyEnd: true,
      },
    ];
    this.allColumns.forEach(element => {
      element.isFilterAllow = false;
    });
    this.searchSettings = [
      {
        display_field: 'Service Name',
        value_field: 'service_name',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.TEXT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.STRING,
      }
    ];

    this.serviceNeoGridSettings = {
      showAdvanceSearch: false,
      showFooter: false,
      showPagination: true,
      tableId: this.tableKeyEnum.SERVICE_GRID_LIST,
      perPage: this.paginationData.rowsPerPage,
      pageNumber:this.paginationData.pageNumber - 1,
      pageSizeOptions: [5, 10, 15, 20, 50, 100],
      serverSideSortPagination: true,
      serverSideFilter: true,
      pageTotalLength: 0,
      sort: true,
      defaultSortCol: '',
      defaultSortDirection: 'asc',
      // enableMultiDelete: true,
      columns: this.allColumns,
      deleteMsgBoxTitle: 'Are you sure to delete this Services?',
      deleteMsgBoxDetail: 'Services Name :${service_name} ',
    };
    if (this.serviceNeoGridSettings.serverSideSortPagination && this.serviceNeoGridSettings.perPage) {
      this.setPaginationPerPage(this.serviceNeoGridSettings.perPage);
    }
  }

  ngOnInit() {
    this.setDefaultPageSize(this.tableKeyEnum.SERVICE_GRID_LIST)
    this.setGridSetting();
    this.initPaginationSort();
    const filterSubscription = this.searchService.getFilterOptions().subscribe((obj) => {
      // if (obj && obj.filters) {
      this.applyFilter(obj);
      // }else
    });
    this.subscriptions.push(filterSubscription);
  }

  getServiceData(gridSetting : any) {
    let fetchSettingData = this.serviceNeoGridSettings.serverSideSortPagination ? gridSetting : null;
    let params = this.getGridSettingInfo(fetchSettingData);
    this.serviceService.getServiceDataWithPageing(params).subscribe(result => {
      this.serviceDataForGrid = result;
      this.filteredServiceDataForGrid = JSON.parse(JSON.stringify(this.serviceDataForGrid.content));
      this.refreshDataSource(this.serviceDataForGrid.content);
      this.totalRecords = result.pageDetails ? result.pageDetails.totalRecords : 0;
      this.serviceNeoGridSettings.pageTotalLength = this.totalRecords;
    });
  }

  getListWithParams() {
    if(Array.isArray(this.searchData)){
      if(this.searchData.length > 0){
        if(this.searchData[0].filterValue && this.searchData[0].filterValue !== ''){
          this.paginationData.pageNumber = 1;
        }
      }
    }
    let config = { page: this.paginationData, order: this.orderingData, search: this.searchData};
    this.getServiceData(config);
  }

  applyFilter(filterObj) {
    let filteredDataForGrid = JSON.parse(JSON.stringify(this.serviceDataForGrid.content));
    if (filterObj && filterObj.filters) {
      // Client Side Filter
      filteredDataForGrid = this.searchService.getFilteredData(filterObj.filters, this.serviceDataForGrid.content);
    }
    this.refreshDataSource(filteredDataForGrid);
  }

  refreshDataSource(data) {
    if (data) {
      this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    }
  }

  // onEdit(event) {
  //   this.setUpdateValueInForm(event.RowData);
  // }

  onEdit(event) {
    ////console.log(event);
    this.setUpdateValueInForm(event);
  }

  // onDelete(event) {
  //   let self = this;
  //   if (event.deletClicked) {
  //     self.delete(event.RowData);
  //   }
  // }

  onDelete(event) {
     if (event) {
       this.commonDeleteMsgBox(this.serviceNeoGridSettings,event,this.delete.bind(this));
     }
  }

  delete(objEvent) {
    let self = this;
    let selected_service_data = objEvent.event;
    if (objEvent.deleteClicked) {
      this.serviceService.deleteService(selected_service_data.service_id).subscribe((result) => {
        if(result.status !== 200){
          this.tosterservice.error(result.ERROR);
        }
        else{
          this.tosterservice.success('Service is deleted successfully');
          this.show_update = false;
          self.serviceDataForGrid.content.forEach(function(item, index) {
            if (item.service_id === selected_service_data.service_id) {
              self.serviceDataForGrid.content.splice(index, 1);
            }
          });
          self.refreshDataSource(self.serviceDataForGrid.content);
        }
       
      },err => {
        this.tosterservice.error(err.error.status + " " + err.error.ERROR);
      });
    }
  }

  setUpdateValueInForm(rowData) {
    this.router.navigate(['plan-management/service/add-service',rowData.service_id]);
 }

 onAddServiceClick() {
  this.router.navigate(['plan-management/service/add-service']);
 }

  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.subscriptions.map((subscription) => {
        subscription.unsubscribe();
      });
    }
  }

}
